import React from 'react';
import { BlockStack, InlineStack, Text, Button, Divider } from '@shopify/polaris';
import { getPaymentBalance, isPaidOnline, getPaymentMethodLabel } from '../../utils/orderEditRules';

const isCodOrder = order => !order?.payment?.method || order.payment.method === 'cod';

const PaymentBalanceSection = ({ order, canManageOrders, onRecordPayment }) => {
  if (!order) return null;
  const currency = order.payment?.currency || 'EGP';
  const fmt = value => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value || 0);
  const balance = getPaymentBalance(order);

  if (isCodOrder(order)) {
    return (
      <InlineStack align="space-between">
        <Text variant="bodyMd" fontWeight="medium">Amount to collect:</Text>
        <Text variant="bodyMd" fontWeight="medium">{fmt(balance.total)}</Text>
      </InlineStack>
    );
  }

  const status = String(order.status || '').toLowerCase();
  const canRecord = canManageOrders
    && isPaidOnline(order)
    && balance.amount_due > 0
    && status !== 'cancelled'
    && status !== 'returned';
  const additional = Array.isArray(order.payment?.additional_payments)
    ? order.payment.additional_payments
    : [];

  return (
    <BlockStack gap="200">
      <InlineStack align="space-between">
        <Text variant="bodyMd" fontWeight="medium">Paid:</Text>
        <Text variant="bodyMd">{fmt(balance.paid_amount)}</Text>
      </InlineStack>
      <InlineStack align="space-between">
        <Text variant="bodyMd" fontWeight="medium">Amount due:</Text>
        <Text
          variant="bodyMd"
          fontWeight="bold"
          tone={balance.amount_due > 0 ? 'critical' : undefined}
        >
          {fmt(balance.amount_due)}
        </Text>
      </InlineStack>
      {canRecord && (
        <InlineStack align="end">
          <Button onClick={onRecordPayment}>Record payment</Button>
        </InlineStack>
      )}
      {additional.length > 0 && (
        <>
          <Divider />
          <Text variant="headingSm" as="h3">Additional payments</Text>
          {additional.map((p, index) => (
            <InlineStack key={p.payment_request_id || index} align="space-between" gap="200">
              <Text variant="bodySm">
                {fmt(p.amount)} - {getPaymentMethodLabel(p.method)}
                {p.reference ? ` - ${p.reference}` : ''}
              </Text>
              <Text variant="bodySm" tone="subdued">
                {p.recorded_at ? new Date(p.recorded_at).toLocaleDateString() : ''}
                {p.recorded_by_name ? ` - ${p.recorded_by_name}` : ''}
              </Text>
            </InlineStack>
          ))}
        </>
      )}
    </BlockStack>
  );
};

export default PaymentBalanceSection;
